import React, { useState } from 'react'
import { setupI18n } from '@lingui/core'
import sk from '../../../locales/sk/messages'

export const ContactLinks: React.SFC<{
  phone: string
  email: string
  emailFirst?: boolean
  light?: boolean
}> = ({ phone, email, emailFirst, light }) => {
  const [catalogs] = useState({ sk } as any)
  const i18n = setupI18n({ language: 'sk', catalogs })

  return (
    <ul className="list--unstyled mb flex flex-col">
      <li className={emailFirst ? 'order-last' : ''}>
        <a
          href={`tel:${i18n.t`${phone}`}`}
          className={`text-small ${light ? 'text-color-grey-600' : ''}`}
          style={{ fontSize: '0.95rem' }}>
          {i18n.t`${phone}`}
        </a>
      </li>
      <li>
        <a
          href={`mailto:${i18n.t`${email}`}`}
          className={`link-black text-small ${light ? 'text-color-grey-600' : ''}`}
          style={{ fontSize: '0.95rem' }}>
          {i18n.t`${email}`}
        </a>
      </li>
    </ul>
  )
}
